/* eslint-disable max-lines-per-function */
/**
 * @file  sec
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */
import React, {useEffect, useState, useContext} from 'react';
import {Table, message, Pagination, Button, Divider} from 'antd';
import {Picker, ActionSheet} from 'antd-mobile';
import moment from 'moment';
import Iconfont from '~/component/Iconfont';
import {pageSection} from '~/utils/common';
import {DEFAULT_PAGE_NUM, DEFAULT_PAGE_SIZE} from '~/utils/http';
import {getSecList} from '~/service/sec';
import {BasicLayoutContext} from '~/layout/BasicLayout';

import './index.less';

const columns = [
    {
        title: 'Form',
        dataIndex: 'form',
        width: 110,
    },
    {
        title: 'Desciption',
        dataIndex: 'description',
        width: 230,
    },
    {
        title: 'Date',
        dataIndex: 'fileTime',
        width: 150,
        // eslint-disable-next-line object-shorthand
        render: (text, record) => {
            const {fileTime} = record;

            return (
                <>
                    {moment(fileTime).format('YYYY-MM-DD')}
                </>
            );
        }
    },
    {
        title: 'Format',
        dataIndex: 'format',
        render: (text, record) => (
            <>
                <div className="format-btn">
                    <Button
                        icon={<Iconfont type="iconhtml" className="iconhtml" />}
                        // eslint-disable-next-line
                        onClick={() => {
                            window.open(`/html/${record.id}`);
                        }}
                    >
                        HTML
                    </Button>
                    <Button
                        icon={<Iconfont type="iconxiazai" className="iconxiazai" />}
                        // eslint-disable-next-line
                        onClick={() => {
                            window.open(`/api/sec/download.json?id=${record.id}`);
                        }}
                    >
                        Word
                    </Button>
                </div>
                <div className="format-download">
                    <Button
                        icon={<Iconfont type="iconxiazai" className="iconxiazai" />}
                        // eslint-disable-next-line
                        onClick={() => {
                            window.open(`/api/sec/pdf.json?id=${record.id}`);
                        }}
                    >
                        PDF
                    </Button>
                    <Button
                        icon={<Iconfont type="iconxiazai" className="iconxiazai" />}
                        // eslint-disable-next-line
                            onClick={() => {
                            window.open(`/api/sec/download/excel.json?id=${record.id}`);
                        }}
                    >
                        Excel
                    </Button>
                </div>
                {
                    record.form === '20-F' && (
                        <div className="xbrl-btn">
                            <Button
                                icon={<Iconfont type="iconhtml" className="iconhtml" />}
                                // eslint-disable-next-line
                                onClick={() => {
                                    window.open(record.xbrlUrl);
                                }}
                            >
                                XBRL
                            </Button>
                        </div>
                    )
                }

            </>
        )
    }
];


function SEC() {
    const [list, setList] = useState([]);
    const [total, setTotal] = useState(0);
    const [id, setId] = useState('');
    const [pageNumMobile, setPageNumMobile] = useState([]);
    const layoutContext = useContext(BasicLayoutContext);
    const {isMobile} = layoutContext ?? {};

    const [pageDto, setPageDto] = useState({
        pageNum: DEFAULT_PAGE_NUM,
        pageSize: DEFAULT_PAGE_SIZE
    });
    const {pageNum} = pageDto;

    const [clicked, setClicked] = useState('none');

    function showActionSheet(event) {
        const {id} = event.currentTarget.dataset;
        setId(id);
        const BUTTONS = [
            'HTML',
            'Word',
            'Pdf',
            'Excel',
            'Cancel'
        ];
        ActionSheet.showActionSheetWithOptions({
            options: BUTTONS,
            cancelButtonIndex: BUTTONS.length - 1,
            destructiveButtonIndex: BUTTONS.length - 2,
            maskClosable: true,
        },
        buttonIndex => {
            setClicked(BUTTONS[buttonIndex]);
        });
    }

    // 移动端对每个按钮做处理
    if (clicked === 'HTML') {
        window.open(`/html/${id}`);
        setClicked('none');
    }

    if (clicked === 'Word') {
        window.open(`/api/sec/download.json?id=${id}`);
        setClicked('none');
    }

    if (clicked === 'Pdf') {
        window.open(`/api/sec/pdf.json?id=${id}`);
        setClicked('none');
    }

    if (clicked === 'Excel') {
        window.open(`/api/sec/download/excel.json?id=${id}`);
        setClicked('none');
    }


    const columnsMobile = [
        {
            title: 'Form',
            dataIndex: 'form',
            width: 110,
        },
        {
            title: 'Date',
            dataIndex: 'fileTime',
            width: 200,
            // eslint-disable-next-line object-shorthand
            render: (text, record) => {
                const {fileTime} = record;

                return (
                    <>
                        {moment(fileTime).format('YYYY-MM-DD')}
                    </>
                );
            }
        },
        {
            title: 'Format',
            dataIndex: 'format',
            render: (text, record) => (
                <>
                    <Button
                        type="text"
                        data-id={record.id}
                        icon={<Iconfont type="iconxiala" className="iconxiazai-mobile" />}
                        onClick={showActionSheet}
                    />
                </>
            )
        }
    ];

    function handlePageChange(page, pageSize) {
        setPageDto({
            pageNum: page,
            pageSize
        });
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        getSecList({pageDto})
            .then(({data: {list, total}}) => {
                setList(list);
                setTotal(total);
            })
            .catch(() => {
                message.error('获取分页列表信息失败');
            });
    }, [pageDto]);


    function handlePageChangeMobile(value) {
        setPageDto({
            pageNum: value[0],
            pageSize: 20
        });
        setPageNumMobile(value);
    }


    /**
     * 处理分页数据
     */
    const pageSelect = [];
    pageSelect.push(pageSection(total, DEFAULT_PAGE_SIZE));

    return (
        <div className="sec-container">
            {
                isMobile && (
                    <>
                        <div className="sec-container-title">
                            SEC Filings
                        </div>
                        <Divider />
                    </>
                )
            }
            <Table
                columns={isMobile ? columnsMobile : columns}
                dataSource={list}
                pagination={false}
            />

            {
                isMobile
                    ? (
                        <>
                            <Divider />
                            <div className="releases-content-year-filter">
                                PaginationShow
                                <Picker
                                    data={pageSelect}
                                    cascade={false}
                                    okText="determine"
                                    dismissText="cancel"
                                    value={pageNumMobile}
                                    onChange={handlePageChangeMobile}
                                >
                                    <div className="releases-content-year">
                                        {pageNum}
                                        <Iconfont type="iconxiala" className="iconxiala" />
                                    </div>
                                </Picker>
                            </div>
                            <Divider />

                            <div className="pagination-total-mobile">
                                {
                                    total > 0 && (
                                        <div className="total">
                                            Total Records:
                                            {' '}
                                            {total}
                                        </div>
                                    )
                                }
                            </div>
                        </>
                    )
                    : (
                        <div className="pagination-total">
                            <div className="total">
                                Total Records:
                                {total}
                            </div>

                            <Pagination
                                onChange={handlePageChange}
                                defaultPageSize={20}
                                defaultCurrent={1}
                                total={total}
                                current={pageNum}
                                showSizeChanger
                                hideOnSinglePage
                            />
                        </div>
                    )
            }


        </div>
    );
}

export default SEC;
